import { apiSlice } from "../../app/api/apiSlice";

export const getEnhancedConditionsEfolderDocumentsListApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getEnhancedConditionsEfolderDocumentsList: builder.mutation({
			query: (credentials) => ({
				url: `api/v1/loan/get_enhanced_conditions_efolder_documents/`,
				method: "GET",
			}),
		}),
	}),
});

export const { useGetEnhancedConditionsEfolderDocumentsListMutation: useEnhancedConditionsEfolderDocumentsListMutation } =
	getEnhancedConditionsEfolderDocumentsListApiSlice;